import { z } from "zod";
import {
  ControlDataTypeKey,
  Types
} from "../prop-controllers";
import { P, match } from "ts-pattern";
import { imageDataV0Schema, imageDataV1Schema } from "../data";
import { linkDataSchema } from "../link";
const imagesDataV0ItemSchema = z.object({
  key: z.string(),
  props: z.object({
    link: linkDataSchema.optional(),
    file: imageDataV0Schema.optional(),
    altText: z.string().optional()
  })
});
const imagesDataV0Schema = z.array(imagesDataV0ItemSchema);
const imagesDataV1ItemSchema = z.object({
  key: z.string(),
  version: z.literal(1),
  props: z.object({
    link: linkDataSchema.optional(),
    file: imageDataV1Schema.optional(),
    altText: z.string().optional()
  })
});
const imagesDataItemSchema = z.union([
  imagesDataV0ItemSchema,
  imagesDataV1ItemSchema
]);
const imagesDataSchema = z.array(imagesDataItemSchema);
const imagesPropControllerDataV0Schema = z.array(imagesDataV0ItemSchema);
const imagesPropControllerDataV1Schema = imagesDataSchema;
const ImagesPropControllerDataV2Type = "prop-controllers::images::v2";
const imagesPropControllerDataV2Schema = z.object({
  [ControlDataTypeKey]: z.literal(ImagesPropControllerDataV2Type),
  value: imagesPropControllerDataV1Schema
});
const imagesPropControllerDataSchema = z.union([
  imagesPropControllerDataV0Schema,
  imagesPropControllerDataV1Schema,
  imagesPropControllerDataV2Schema
]);
function Images(options = {}) {
  return { type: Types.Images, version: 2, options };
}
function getImagesPropControllerDataImagesData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: ImagesPropControllerDataV2Type },
    (v2) => v2.value
  ).otherwise((v0) => v0);
}
function createImagesPropControllerDataFromImagesData(data, definition) {
  return match(definition).with(
    { version: 2 },
    () => ({
      [ControlDataTypeKey]: ImagesPropControllerDataV2Type,
      value: data
    })
  ).otherwise(() => data);
}
function getImagesPropControllerFileIds(data) {
  const value = getImagesPropControllerDataImagesData(data);
  return value?.flatMap(
    (item) => match(item.props.file).with(P.string, (f) => [f]).with({ type: "makeswift-file", version: 1 }, (f) => [f.id]).with({ type: "external-file", version: 1 }, () => []).with(P.nullish, () => []).otherwise(() => [])
  ) ?? [];
}
function copyImagesData(data, context) {
  if (data == null)
    return data;
  return data.map(copyImagesPanelItem);
  function copyImagesPanelItem(imagesPanelItem) {
    if ("version" in imagesPanelItem) {
      return {
        ...imagesPanelItem,
        props: {
          ...imagesPanelItem.props,
          file: match(imagesPanelItem.props.file).with({ type: "makeswift-file", version: 1 }, (f) => ({
            ...f,
            id: context.replacementContext.fileIds.get(f.id) ?? f.id
          })).otherwise((f) => f)
        }
      };
    } else {
      return {
        ...imagesPanelItem,
        props: {
          ...imagesPanelItem.props,
          file: match(imagesPanelItem.props.file).with(
            P.string,
            (f) => context.replacementContext.fileIds.get(f) ?? f
          ).otherwise((f) => f)
        }
      };
    }
  }
}
function copyImagesPropControllerData(data, context) {
  return match(data).with(void 0, () => void 0).with({ [ControlDataTypeKey]: ImagesPropControllerDataV2Type }, (v1) => {
    const value = copyImagesData(v1.value, context);
    if (value == null)
      return void 0;
    return {
      [ControlDataTypeKey]: ImagesPropControllerDataV2Type,
      value
    };
  }).otherwise((v0) => copyImagesData(v0, context));
}
export {
  Images,
  ImagesPropControllerDataV2Type,
  copyImagesPropControllerData,
  createImagesPropControllerDataFromImagesData,
  getImagesPropControllerDataImagesData,
  getImagesPropControllerFileIds,
  imagesDataSchema,
  imagesPropControllerDataSchema
};
//# sourceMappingURL=images.js.map